import { EmptyValue } from "@bcc/components/ui";
import type { PurchaseOrderInvoice } from "@shared/types/payout";
import { CellContext } from "@tanstack/react-table";

export const InvoiceVatRateCell = (props: CellContext<PurchaseOrderInvoice, unknown>) => {
  const lines = props.row.original.invoiceLines;
  const vatRate = lines.length > 0 ? lines[0]?.vatRate : undefined;
  const { invoiceStatus } = props.row.original;
  if (invoiceStatus === "Unposted" || vatRate == null) {
    return (
      <div className="text-sm leading-snug">
        <EmptyValue />
      </div>
    );
  }

  return <div>{vatRate}%</div>;
};
